(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5185],{

/***/ 65185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ RobustMarketingAppstore_RobustMarketingAppstore; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
// EXTERNAL MODULE: ../../libs/matcha/components/IconWrapper/index.ts + 2 modules
var IconWrapper = __webpack_require__(79600);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Brandbook.ts + 92 modules
var Brandbook = __webpack_require__(79550);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/Marketing/components/RobustMarketingAppstore/assets/RobustMarketingAppstore@2x.png
var RobustMarketingAppstore_2x = __webpack_require__(57058);
var RobustMarketingAppstore_2x_default = /*#__PURE__*/__webpack_require__.n(RobustMarketingAppstore_2x);
// EXTERNAL MODULE: ./src/views/Marketing/components/RobustMarketingAppstore/assets/RobustMarketingAppstore.webp
var RobustMarketingAppstore = __webpack_require__(38851);
var RobustMarketingAppstore_default = /*#__PURE__*/__webpack_require__.n(RobustMarketingAppstore);
// EXTERNAL MODULE: ./src/views/Marketing/components/RobustMarketingAppstore/assets/RobustMarketingAppstore@2x.webp
var assets_RobustMarketingAppstore_2x = __webpack_require__(32823);
var assets_RobustMarketingAppstore_2x_default = /*#__PURE__*/__webpack_require__.n(assets_RobustMarketingAppstore_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Marketing/components/RobustMarketingAppstore/RobustMarketingAppstoreImage.tsx








var RobustMarketingAppstoreImage = function RobustMarketingAppstoreImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((RobustMarketingAppstore_default()), ", ").concat((assets_RobustMarketingAppstore_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, {
      src: (RobustMarketingAppstore_2x_default()),
      alt: "Robust",
      width: "640",
      height: "417",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var RobustMarketingAppstore_RobustMarketingAppstoreImage = (RobustMarketingAppstoreImage);

var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "ej92kv90"
} : 0)("position:absolute;top:0;left:50%;width:140%;max-width:407px;height:auto;transform:translate(-50%, 0%);", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:831px;}", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{max-width:731px;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./src/views/Marketing/components/RobustMarketingAppstore/RobustMarketingAppstore.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var copy = {
  heading: "Endless opportunities, one centralized platform",
  description: "Activate your audiences in real-time across ".concat("450", "+ integrations.")
};
var RobustMarketingAppstore_link = {
  text: "Explore Segment Connections",
  url: "/product/connections/"
};
var features = [{
  heading: "Consistency across channels and campaigns",
  description: "Use the same audiences & data in all your tools to provide a consistent message across all channels.",
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* NamingConventionsIcon */.eo, {})
}, {
  heading: "Effortlessly expand your marketing reach",
  description: "Test new channels for your campaigns instantly, without requiring engineering & analytical oversight.",
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* AnalyticsIcon */.Ie, {})
}];
var RobustMarketingSection = function RobustMarketingSection() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionComponent, {
      variant: "2Col",
      copyVariant: "narrow",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h2",
            tag: "h2",
            children: copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            children: copy.description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
            href: (0,getAbsoluteUrl/* default */.Z)(RobustMarketingAppstore_link.url, pageConfig),
            children: RobustMarketingAppstore_link.text
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrackWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
            children: features.map(function (feature, index) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* default */.ZP, {
                alignment: "left",
                headerPosition: "left",
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Header */.h4, {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper/* default */.Z, {
                    elevation: 1,
                    variant: "circle",
                    children: feature.icon
                  })
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                    children: feature.heading
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                    children: feature.description
                  })]
                })]
              }, index);
            })
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionContents, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RobustMarketingAppstore_RobustMarketingAppstoreImage, {})
      })]
    })
  });
};

var SectionComponent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "enzvxsm3"
} : 0)("overflow-x:visible;", Section/* Wrapper */.im, "{", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("md");
}, "{padding-bottom:0px;}}" + ( true ? "" : 0));

var ColumnTrackWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "enzvxsm2"
} : 0)( true ? {
  name: "1mcm32d",
  styles: "margin-top:40px;max-width:640px"
} : 0);

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "enzvxsm1"
} : 0)("display:grid;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding-bottom:20px;}" + ( true ? "" : 0));

var SectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "enzvxsm0"
} : 0)("position:relative;&::after{content:'';display:block;height:0;overflow:hidden;position:relative;pointer-events:none;padding-top:85%;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{padding-top:80%;}}" + ( true ? "" : 0));

/* harmony default export */ var RobustMarketingAppstore_RobustMarketingAppstore = (RobustMarketingSection);
;// CONCATENATED MODULE: ./src/views/Marketing/components/RobustMarketingAppstore/index.ts


/***/ }),

/***/ 57058:
/***/ (function(module) {

module.exports = "/_next/static/images/RobustMarketingAppstore@2x-831c17bc07087527f2dc7a8bfb78381f.png";

/***/ }),

/***/ 38851:
/***/ (function(module) {

module.exports = "/_next/static/images/RobustMarketingAppstore-3509fe8cdaac3fc1b8a6c8b223f0f3a7.webp";

/***/ }),

/***/ 32823:
/***/ (function(module) {

module.exports = "/_next/static/images/RobustMarketingAppstore@2x-025867afbcf222f0f7ddcaecb1a42c3d.webp";

/***/ })

}]);